import React from "react";
import Table from "../../../../../components/Table";
import { engineersPageLoad } from "../../../actions/engineers";
import {
  engineers,
  engineersLoadInProgress,
} from "../../../selectors/engineers";
import { connect } from "react-redux";
import PageTitle from "../../../components/PageTitle";
import { push } from "react-router-redux";
import { Button, Glyphicon, Panel } from "react-bootstrap";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";
import DisableBadge from "sc/ui/sites/oncall/components/DisableBadge";

export default connect(
  (state, ownProps) => ({
    engineers: engineers(state),
    loading: engineersLoadInProgress(state),
  }),
  (dispatch, ownProps) => ({
    onLoad: () => dispatch(engineersPageLoad()),
    onAddEngineer: () => dispatch(push("/engineers/new")),
    onEditEngineer: id => dispatch(push(`/engineer/edit/${id}`)),
  }),
)(
  componentWithLoadTrigger(props => {
    const actions = [
      {
        id: "edit-engineer",
        text: " Edit",
        className: "btn-primary",
        glyph: "glyphicon glyphicon-pencil",
        onClick: props.onEditEngineer,
      },
    ];

    const columns = [
      {
        header: "Name",
        data: engineer => `${engineer.firstName} ${engineer.lastName}`,
        badges: engineer => {
          const allBadges = [];
          if (!engineer.enabled)
            allBadges.push([<DisableBadge key="disabled-badge" />]);
          return allBadges;
        },
      },
      {
        header: "Region",
        data: engineer => engineer.regionName,
      },
    ];

    return (
      <div id="engineers-list-page">
        <PageTitle title="Engineers" />
        <Button
          id="add-engineer"
          onClick={props.onAddEngineer}
          className="btn-success"
        >
          <Glyphicon glyph="glyphicon glyphicon-plus" />
          &nbsp;Add New Engineer
        </Button>
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Engineers list</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Table
              data={props.engineers}
              columns={columns}
              actions={actions}
              identityProperty="id"
              noDataMessage="No engineers defined"
              loading={props.loading}
              loadingMessage="Loading..."
            />
          </Panel.Body>
        </Panel>
      </div>
    );
  }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/partner-admin/engineers/List.js